import { render, staticRenderFns } from "./company-list.vue?vue&type=template&id=70a70740&"
import script from "./company-list.vue?vue&type=script&lang=js&"
export * from "./company-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports